import { LinkBox, SelectField } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';

const PrhClaimType = ({
    index,
    claimTypes,
    setClaimTypes,
    setCompensations
}: {
    index: number;
    claimTypes: string[];
    setClaimTypes: React.Dispatch<React.SetStateAction<string[]>>;
    setCompensations: React.Dispatch<React.SetStateAction<number[]>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const changeClaimType = (prev: string[], index: number, value: string): string[] => {
        const tempCompensations = [...prev];
        tempCompensations[index] = value;
        return tempCompensations;
    };
    const changeCompensation = (prev: number[], index: number, value: number): number[] => {
        const tempCompensations = [...prev];
        tempCompensations[index] = value;
        return tempCompensations;
    };

    const mapClaimStateToClamTypeUi = (claimType: string): string => {
        if (!claimType) return '';
        if (claimType === 'Pipe') return 'Skader på skjulte rør/andre skader';
        return claimType;
    };

    return (
        <>
            <h4>
                {getHippoText(
                    `DSS-COVERABLE-INFORMATION-STEP-${index + 1}-CLAIM${index === 0 ? '' : 'S'}-HEADER`
                )}
            </h4>
            <SelectField
                label={getHippoText(`DSS-COVERABLE-INFORMATION-STEP-CLAIM-TYPE-DROPDOWN`)}
                options={['Skybrud', 'Skader på skjulte rør/andre skader', 'Anden skade']}
                value={mapClaimStateToClamTypeUi(claimTypes[index] ?? '')}
                onChange={(event) => {
                    const claimValue =
                        event.target.value === 'Skader på skjulte rør/andre skader'
                            ? 'Pipe'
                            : event.target.value;
                    setClaimTypes((prev) => changeClaimType(prev, index, claimValue));
                }}
                isValid
                required
            />
            {claimTypes[index] === 'Skybrud' && (
                <>
                    <p className="strong">
                        {getHippoText('DSS-COVERABLE-INFORMATION-STEP-CLAIM-SUBHEADER')}
                    </p>
                    <div className="u-display-flex u-flex-column u-flex-items-start u-gap-5">
                        <LinkBox
                            className="flos-box"
                            title={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CLAIM-0-70000')}
                            onClick={() => {
                                setCompensations((prev) => changeCompensation(prev, index, 1));
                            }}
                        />
                        <LinkBox
                            className="flos-box"
                            title={getHippoText(
                                'DSS-COVERABLE-INFORMATION-STEP-CLAIM-UNDER-300000'
                            )}
                            onClick={() => {
                                setCompensations((prev) => changeCompensation(prev, index, 2));
                            }}
                        />
                        <LinkBox
                            className="flos-box"
                            title={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CLAIM-OVER-300000')}
                            onClick={() => {
                                setCompensations((prev) => changeCompensation(prev, index, 3));
                            }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default PrhClaimType;
